import { render, staticRenderFns } from "./Swer3-game.vue?vue&type=template&id=12462371"
import script from "./Swer3-game.vue?vue&type=script&lang=js"
export * from "./Swer3-game.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports